var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container flex items-middle"},[_vm._m(0),_c('div',{staticClass:"name",style:({ fontSize: _vm.fontSize })},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("@/assets/imgs/u450.svg")}})])
}]

export { render, staticRenderFns }